import "./App.css";
import Layout from "./components/Layout/Layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage/Homepage";
import Categories from "./pages/Categories/Categories";
import Moviedetails from "./pages/Moviedetails/Moviedetails";

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/">
              <Route index element={<Homepage />} />
              <Route path="category/:id" element={<Categories />} />
              <Route path="moviedetails/:id" element={<Moviedetails />} />
            </Route>
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
